import { render, staticRenderFns } from "./DownloadFilePage.vue?vue&type=template&id=7e8eb996&scoped=true&"
import script from "./DownloadFilePage.vue?vue&type=script&lang=js&"
export * from "./DownloadFilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8eb996",
  null
  
)

export default component.exports